import { useConfigProvider } from '@/lib/context';
import { IPlatformPageSection, PlatformInstructionalVideo } from '@/shared/types/platform-pages';
import Image from 'next/image';

interface IProps {
  content: IPlatformPageSection;
}

const InstructionalVideoSection = ({ content }: IProps) => {
  const { isMobile } = useConfigProvider();

  return (
    <div className="section-inner videos">
      {(content.instructionalVideos || []).map((video: PlatformInstructionalVideo, i: number) => {
        return (
          <a key={i} className="video" href={video.videoUrl} target="_blank" rel="noreferrer">
            <Image
              className="video-thumbnail"
              src={video.thumbnail}
              width={isMobile ? 100 : 124}
              height={isMobile ? 100 : 124}
              alt={video.altText}
            />
          </a>
        );
      })}
    </div>
  );
};

export default InstructionalVideoSection;
